import React from 'react';
import { Box, Typography, Dialog, IconButton, Grid } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { makeStyles } from '@mui/styles';
import { KeyValueProps } from '../../../../types/Common';
import { typeMappingHandler } from '../../../../constants/keysMapping';
import './clifton.scss';

interface GridItemProps {
  color: string;
  title: string;
  items: KeyValueProps[];
}

const useStyles = makeStyles(() => ({
  paper: {
    borderRadius: '1rem',
    direction: 'rtl',
  },
}));

const GridItem: React.FC<GridItemProps> = (props) => {
  const { color, items, title } = props;

  return (
    <Box className='gridItemContainer'>
      <Typography color={color} className='title'>
        {title}
      </Typography>

      <Box className='head'>
        <Typography>نام</Typography>
        <Typography>اولویت</Typography>
        <Typography>نمره</Typography>
      </Box>

      {items?.map((item: KeyValueProps, index) => (
        <Box className='gridItemContent' key={item.key}>
          <Box>
            <Box className='square' bgcolor={color} />
            <Typography color='text.main' className='title'>
              {typeMappingHandler(item.key).message}
            </Typography>
          </Box>

          <Typography color='text.main' textAlign='center' pl={6}>
            {index + 1}
          </Typography>
          <Typography color='text.main'>{item.value?.toString().slice(0, 4)}</Typography>
        </Box>
      ))}
    </Box>
  );
};

interface CliftonDialogProps {
  openCliftonDialog: boolean;
  setOpenCliftonDialog: () => void;
  EG1: KeyValueProps[];
  EG2: KeyValueProps[];
  EG3: KeyValueProps[];
  EG4: KeyValueProps[];
  cliftonRef: any;
  exporting?: boolean;
}

const CliftonDialog: React.FC<CliftonDialogProps> = (props) => {
  const { openCliftonDialog, setOpenCliftonDialog, EG1, EG2, EG3, EG4, cliftonRef, exporting } =
    props;
  const styles = useStyles();

  const handleClose = () => setOpenCliftonDialog();

  return (
    <Dialog
      onClose={handleClose}
      open={openCliftonDialog}
      maxWidth='xl'
      classes={{ paper: styles.paper }}
    >
      <Box className='mainDialog' ref={cliftonRef}>
        {!exporting && (
          <Box className='header'>
            <Typography color='text.main'>برقراری ارتباط</Typography>
            <IconButton onClick={handleClose}>
              <CloseRoundedIcon color='action' />
            </IconButton>
          </Box>
        )}

        <Grid container mt={1} spacing={2}>
          <Grid item xl={3} sm={6} xs={12}>
            <GridItem color='#9017A3' items={EG1} title={typeMappingHandler('EG1').message} />
          </Grid>
          <Grid item xl={3} sm={6} xs={12}>
            <GridItem color='#FEBE09' items={EG2} title={typeMappingHandler('EG2').message} />
          </Grid>
          <Grid item xl={3} sm={6} xs={12}>
            <GridItem color='#0C6AB0' items={EG3} title={typeMappingHandler('EG3').message} />
          </Grid>

          <Grid item xl={3} sm={6} xs={12}>
            <GridItem color='#CC0056' items={EG4} title={typeMappingHandler('EG4').message} />
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
};

export default CliftonDialog;
